import * as HLF from "html-living-framework";
import * as Constants from "Data/Constants";
import * as Topics from "Data/Topics";
import { Button } from "GameObjects/Button";
import { MusicManager } from "Singletons/MusicManager";
import { TimelineLite } from "gsap";

export class MusicGameShareButton extends Button {

    protected _debugText = this._visuals.addChild(HLF.PixiUtils.makeText("", Constants.FONT_GEL_MED_35, 35));
    protected _subscriptions: any[] = [];
    constructor() {
        super(()=>this.onClick(), "button-default", Constants.SPRITESHEET_UI);
        this._debugText.text = "Share";

        this._subscriptions.push(
            PubSub.subscribe(Topics.PLAYBACK_STARTED, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.RECORDING_COUNT_IN, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.RECORDING_ENDED, this.onMessageReceived.bind(this)),
        );
    }

    protected onClick() {
        PubSub.publishSync(HLF.SHOW_POPUP, new HLF.PopupToken(
            Constants.POPUP_MUSIC_SHARE,
            undefined,
            true, // click gray overlay to close
            true, // keyboard escape to close
            { data: MusicManager.Instance.Export() }
         ));
    }

    protected onMessageReceived(pTopic: string, pData: any) {
        switch (pTopic) {
            case Topics.PLAYBACK_STARTED:
            case Topics.RECORDING_COUNT_IN:
                this.hide();
                break;
           case Topics.RECORDING_ENDED:
               this.show();
               break;
        }
    }
}